<template>
    <!-- 添加解读报告 -->
    <a-modal 
        title="新建解读报告"
        :visible="true"
        @ok="toAddReport"
        @cancel="onClose"
        okText="确定"
        cancelText="取消"
        :okButtonProps="{ 
            props: {
                disabled: allowClick
            } 
        }"
    >
        <div class="content">
<!--            <div class="row">-->
<!--                <span>选择城市：</span>-->
<!--                <el-select v-model="searchCity" size="mini" placeholder="请选择">-->
<!--                    <el-option-->
<!--                            v-for="item in cityList"-->
<!--                            :key="item.cityCode"-->
<!--                            :label="item.city"-->
<!--                            :value="item.city">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                <a-cascader -->
<!--                    class="search-input"-->
<!--                    placeholder="请选择城市"-->
<!--                    :options="cityList" -->
<!--                    @change="onCityChange" -->
<!--                    size="small" -->
<!--                    :loadData="loadCityData"-->
<!--                    v-model="searchCity"-->
<!--                />-->
<!--            </div>-->
            <div class="row">
                <span>创建日期：</span>
                <a-date-picker
                    class="search-input"
                    size="small"
                    placeholder="请输入创建日期"
                    v-model="momentDate"
                    @change="datePickerChange"
                />
            </div>
            <div class="row">
                <span>请输入报告名称：</span>
            </div>
            <div class="row">
                <a-input 
                    v-model="reportName"
                    placeholder="请输入报告名称（长度35）"
                    @change="reportNameChange"
                />
            </div>
        </div>
    </a-modal>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import moment from 'moment';
moment.locale('zh-cn');
export default {
    name:"AddReportModal",
    data () {
        return {
            searchCity:'',
            // cityList:[],
            momentDate: moment(),
            createdDate: moment().format('YYYY-MM-DD'),
            reportName: null
        };
    },
    props:{
        show:Boolean,
        cityOptions: Array
    },
    created(){
        // this.cityList = [...this.cityOptions];
    },
    computed:{
        allowClick(){
            let state = true;
            if(this.reportName){
                state = false;
            }
            return state;
        },
        cityList: {
            get() {
                return this.$store.state.optionCityList
            },
            set(val) {
                this.$store.commit('updateoptionCityList', val)
            }
        },
    },
    methods: {
        reportNameChange(){
            if(this.reportName.length > 35){
                this.reportName = this.reportName.slice(0,35);
            }
        },
        // 日期选择
        datePickerChange(momentDate,date){
            this.createdDate = date;
        },
        // 关闭弹窗
        onClose(){
            this.$emit("update:show",false);
        },
        // 新增解读报告
        toAddReport(){
            let token = this.$store.getters.getToken;
            let userId = this.$store.getters.getUserId;
            let name = this.$store.getters.getUserName;
            let reportName = this.reportName;
            // let city = this.searchCity.length ? this.searchCity[this.searchCity.length -1]:"";
            let city =  this.$store.getters.getGpsState.city;
            let timePoint = this.createdDate || moment().format('YYYY-MM-DD');
            let param = `userId=${userId}&reportName=${reportName}&city=${city}&timePoint=${timePoint}&name=${name}`;
            let url = UrlApi.addReport;
            this.$http.post(url,param,{
                headers:{
                    "Authorization":token
                }
            }).then((res)=>{
                let message = res.data.message;
                if(res.data.success){
                    this.$message.success(message);
                    this.$emit("update:show",false);
                }else {
                    this.$message.warning(message);
                }
            })
        },
        // 城市切换
        onCityChange(val){
            this.searchCity = val;
        },
        // load
        loadCityData(city){
            let url = UrlApi.provinceCity;
            const targetOption = city[city.length - 1];
            targetOption.loading = true;
            let params = {
                province: city[0].value
            }
            this.$http.get(url,{
                    params:params
            }).then((res)=>{
                targetOption.loading = false;
                targetOption.children = [];
                res.data.data.map((item)=>{
                    let obj = {
                        label:item.name,
                        value:item.name
                    }
                    targetOption.children.push(obj)
                })
                this.cityList = [...this.cityList];
            })
        },
    }
}

</script>
<style lang="less" scoped>
    .content {
        width: 400px;;
        margin: 0 auto;
        .row {
            display: flex;
            flex-flow: row nowrap;
            align-content: center;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 20px;
        }
    }
</style>